module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload-screen-1-container"
  }, [_c('div', {
    staticClass: "white upload-screen-1-container"
  }, [_c('div', {
    staticClass: "pa-3"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('v-icon', {
    staticClass: "grey--text",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("keyboard_backspace")]), _vm._v(" "), _c('div', {
    staticClass: "grey",
    staticStyle: {
      "width": "100%",
      "height": "1px"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "img-and-caption-container",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "img-container",
    attrs: {
      "xs4": "",
      "md1": ""
    }
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.uploadedImgUrl),
      expression: "uploadedImgUrl"
    }]
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "caption-container",
    attrs: {
      "xs8": "",
      "md11": ""
    }
  }, [_vm._v("\n        The more relevant tags you add to this photo, the more people will discover it.\n      ")])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "tags-container",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    staticClass: "tag-headline text-xs-left"
  }, [_vm._v("\n        Tags: Selected\n      ")]), _vm._v(" "), _c('v-flex', {
    staticClass: "tag-btn-container text-xs-right"
  }, [_c('v-btn', {
    staticClass: "cyan white--text",
    staticStyle: {
      "margin": "0",
      "font-size": "11px"
    },
    attrs: {
      "round": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.openAddTagDialog = true
      }
    }
  }, [_vm._v("\n          Add new\n        ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "tags-chip-container text-xs-left",
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, _vm._l((_vm.$store.state.uploadImage_5.selectedKeywords_uploadImage), function(chip, chipIndex) {
    return _c('div', {
      key: chipIndex,
      staticClass: "text-xl-left",
      staticStyle: {
        "position": "relative"
      }
    }, [_c('v-icon', {
      staticStyle: {
        "position": "absolute",
        "top": "7px",
        "right": "13px",
        "font-size": "18px",
        "z-index": "3",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.$store.state.uploadImage_5.selectedKeywords_uploadImage.splice(chipIndex, 1)
        }
      }
    }, [_vm._v("\n          clear\n        ")]), _vm._v(" "), _c('v-chip', {
      staticClass: "blue black--text",
      staticStyle: {
        "padding": "0 2vh 0 0",
        "font-size": "12px"
      },
      attrs: {
        "outline": "",
        "label": "",
        "small": ""
      }
    }, [_vm._v("\n          " + _vm._s(chip) + "\n        ")])], 1)
  }), 0), _vm._v(" "), _c('v-layout', {
    staticClass: "tags-container mt-3",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    staticClass: "tag-headline text-xs-left"
  }, [_vm._v("\n        Suggested\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-xs-left"
  }, _vm._l((_vm.imaggaSuggestion), function(tag, key) {
    return (
      _vm.$store.state.uploadImage_5.selectedKeywords_uploadImage.indexOf(tag) == -1) ? _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (key < 10),
        expression: "key < 10"
      }],
      staticClass: "suggestion-btn ",
      on: {
        "click": function($event) {
          return _vm.selectThisImaggaSuggestion({
            tag: tag
          })
        }
      }
    }, [_vm._v("\n        " + _vm._s(tag) + "\n      ")]) : _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (
          _vm.$store.state.uploadImage_5.selectedKeywords_uploadImage.indexOf(tag) == -1),
        expression: "\n        $store.state.uploadImage_5.selectedKeywords_uploadImage.indexOf(tag) == -1"
      }],
      staticClass: "suggestion-btn",
      on: {
        "click": function($event) {
          return _vm.deselectThisImaggaSuggestion({
            tag: tag
          })
        }
      }
    }, [_vm._v("\n        " + _vm._s(tag) + "\n      ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "text-xs-right"
  }, [_c('v-btn', {
    staticClass: "primary primary--text",
    attrs: {
      "disabled": _vm.$store.state.uploadImage_5.showShareButton,
      "outline": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.sharePhoto_uploadImage_5({
          url: _vm.$route.query.url,
          resourceType: _vm.$route.query.resourceType,
          publicId: _vm.$route.query.publicId,
          //
          createdAt: _vm.$route.query.createdAt,
          //
          caption: _vm.$route.query.caption,
          locationVisible: _vm.$store.state.uploadImage_2.selectedLocationVisible_uploadImage, // now shifted to this page, instead of being in query
          emotionalAppeal: JSON.parse(_vm.$route.query.emotionalAppeal),
          //
          shareSpotLocation: JSON.parse(_vm.$route.query.shareSpotLocation), //parsed
          hasGeohash: _vm.$route.query.geoLocIsAvailable,
          //
          spotType: JSON.parse(_vm.$route.query.spotType),
          anyoneCanVisitThisSpot: _vm.$route.query.anyoneCanVisitThisSpot,
          //
          keywords: _vm.$store.state.uploadImage_5.selectedKeywords_uploadImage,
          travelInfo: _vm.$route.query.pic_desc,
          _dur2: _vm.$route.query._dur2,
          _mon2: _vm.$route.query._mon2
        })
      }
    }
  }, [_vm._v("\n        share\n      ")])], 1)], 1)]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "300"
    },
    model: {
      value: (_vm.openAddTagDialog),
      callback: function($$v) {
        _vm.openAddTagDialog = $$v
      },
      expression: "openAddTagDialog"
    }
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [_c('h3', {
    staticClass: "text-xs-center"
  }, [_vm._v("Add new tag!")]), _vm._v(" "), _c('v-text-field', {
    ref: "addTag",
    attrs: {
      "label": "Type image tag name"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.newTag.length > 0 ? _vm.$store.state.uploadImage_5.selectedKeywords_uploadImage.push(_vm.newTag) : '';
        _vm.newTag = '';
        _vm.openAddTagDialog = false
      }
    },
    model: {
      value: (_vm.newTag),
      callback: function($$v) {
        _vm.newTag = $$v
      },
      expression: "newTag"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary primary--text",
    attrs: {
      "small": "",
      "outline": ""
    },
    on: {
      "click": function($event) {
        _vm.newTag.length > 0 ? _vm.$store.state.uploadImage_5.selectedKeywords_uploadImage.push(_vm.newTag) : '';
        _vm.newTag = '';
        _vm.openAddTagDialog = false
      }
    }
  }, [_vm._v("\n          add\n        ")])], 1)], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "important-details-container"
  }, [_c('div', {
    staticClass: "important-details"
  }, [_vm._v("Make it popular")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20d5da74","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/uploadImage/uploadImage_5.vue
// module id = 834
// module chunks = 9